import { createRoot } from 'react-dom/client';

import OcTheme from '@openclassrooms/ui-web/theme/components/OcTheme';
import { getActiveLang, getActiveCountry } from '@openclassrooms/translations';
import { getAllTranslations } from '@openclassrooms/translations/i18nService';
import { I18nProvider } from '@openclassrooms/translations/I18nProvider';
import { LocalisationConfigProvider } from '@openclassrooms/localisation/LocalisationConfigProvider';
import { ConfigProvider } from '@openclassrooms/utils/ConfigProvider';
import { getPreferences } from '@openclassrooms/utils/config';
import { getAllLocalisationConfig } from '@openclassrooms/localisation/services';

import store from 'Modules/store';

import browser from '@openclassrooms/utils/browser';
import { RolesProvider } from 'Modules/roles';

import { DataConnectProvider } from '@openclassrooms/data-connect-web/utils';

export default function renderTwigReactComponent(idOrElement, Component, options = {}) {
  const element =
    typeof idOrElement === 'string' ? browser.document.getElementById(idOrElement) : idOrElement;

  if (!element) {
    return;
  }

  let dataToProps = {};
  const jsonScriptTag = element.querySelector('script[type="application/json"]');
  if (jsonScriptTag) {
    dataToProps = JSON.parse(jsonScriptTag.textContent);
  }

  const additionalProps = options.props || {};

  const lang = getActiveLang();
  const country = getActiveCountry();
  const i18n = {
    locale: `${lang}-${country}`,
    messages: getAllTranslations()[lang],
  };

  const content = (
    <OcTheme productionPrefix="dom-services">
      <ConfigProvider config={getPreferences()}>
        <LocalisationConfigProvider config={getAllLocalisationConfig()}>
          <I18nProvider {...i18n}>
            <DataConnectProvider>
              <RolesProvider>
                <Component {...dataToProps} {...additionalProps} />
              </RolesProvider>
            </DataConnectProvider>
          </I18nProvider>
        </LocalisationConfigProvider>
      </ConfigProvider>
    </OcTheme>
  );
  const root = createRoot(element);
  if (options.useRedux) {
    store.renderElementWrappedWithProvider(content, element);
  } else {
    root.render(content);
  }
}
